import Text from 'components/common/Text';
import Logo from 'components/icons/Logo';
import AmexLogoImg from 'images/logo/amex.png';

const AmexBCEBanner = () => {
  return (
    <section className="flex justify-center p-4 text-center font-normal">
      <div className="bp3:flex">
        <div className="max-w-100 flex justify-center p-4">
          <Logo className="h-15 w-20" />
          <div className="p-3 text-2xl font-normal">|</div>
          <img src={AmexLogoImg} className={'max-h-14 max-w-xs'} />
        </div>
        <div className="max-w-2xl flex-auto pt-4">
          <h1 className="text text-green-100">
            American Express Blue Cash Everyday® Card Members can enroll and receive up to $15 in
            monthly statement credits for online purchases at Home Chef on their Blue Cash
            Everyday® Card.
            <Text htmlElement="span" className="block">
              {' '}
              Shipping available in the contiguous US only.
            </Text>
          </h1>
        </div>
      </div>
    </section>
  );
};

export default AmexBCEBanner;
